import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('payroll_components_log')
export class PayrollComponentsLogs {
    
    @PrimaryGeneratedColumn("increment", { name: 'id' })
    id: number;

    @Column("int", {
        name: "employee_id"
    })
    employeeId: number;
    
    @Column('varchar', {
        name: 'employee_name',
    })
    employeeName: string;

    @Column('varchar', {
        name: 'employee_code',
    })
    employeeCode: string;

    @Column('varchar', {
        name: 'employee_type',
    })
    employeeType: string;

    @Column('varchar', {
        name: 'employee_category',
    })
    employeeCategory: string;
    @Column('varchar', {
        name: 'designation',
    })
    designation: number;
    @Column('varchar', {
        name: 'department',
    })
    department: number;

    @Column('varchar', {
        name: 'unit_id',
    })
    unitId: number;

    @Column("varchar", {
        name: "transaction_name"
    })
    transactionName : string;


    @Column('varchar',{
        name:"type"
    })
    type:string

    // @Column("int", {
    //     name: "percentage"
    // })
    // percentage: number;

    @Column("int", {
        name: "amount"
    })
    amount: number;

    @Column("int", {
        name: "terms"
    })
    terms: number;

    @Column("int", {
        name: "period"
    })
    period: number;

    @Column('boolean', {
        name: 'is_active',
        default: true,
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    
}